import { cities as provincePaths } from "turkey-map-react/lib/data/index.js";

export interface ProvinceMapFeature {
  code: string;
  mapId: string;
  name: string;
  plateNumber: number;
  path: string;
  ariaLabel: string;
}

export const provinceMapFeatures: ProvinceMapFeature[] = provincePaths
  .map((province) => ({
    code: `TR-${String(province.plateNumber).padStart(2, "0")}`,
    mapId: province.id,
    name: province.name,
    plateNumber: province.plateNumber,
    path: province.path,
    ariaLabel: `${province.name} ili`
  }))
  .sort((left, right) => left.plateNumber - right.plateNumber);

if (provinceMapFeatures.length !== 81) {
  throw new Error("Turkey map must contain exactly 81 provinces");
}
